import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import { EffectFade, Pagination } from 'swiper/modules';
export default class Commitments {
    constructor() {
        this.sections = document.querySelectorAll('.commitments');
        this.modal = document.querySelector('.modalCommitments')
        this.modalContent = this.modal.querySelector('.content')
        
        this.ready();
    }

    ready() {

        this.sections.forEach(section => {

            const sectionSliders = section.querySelectorAll('.swiper--commitments')
            sectionSliders.forEach(slider => {

                const swiper = new Swiper(slider, {
                    modules: [Pagination, EffectFade],
                    speed: 500,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    slidesPerView: 1,
                    allowTouchMove: false,
                    spaceBetween: 0,
                    pagination: {
                        el: section.querySelector(".swiper-pagination-custom-years"),
                        clickable: true,
                        renderBullet: (index, className) => {
                            const getNameBullet = slider.querySelectorAll('.swiper-slide-commitmentsYear')[index].dataset.ano
                            return '<button class="' + className + '"><span></span> ' + (getNameBullet) + '</button>'; 
                        },
                    },
                    lockClass: 'navigationLock'
                });
                
                const yearsSliders = slider.querySelectorAll('.swiper--commitments-year')
                yearsSliders.forEach((sliderYear, index) => {
                    sliderYear.classList.add('slider-year-'+index)
                    if(sliderYear.querySelectorAll('.swiper-slide').length > 0) {
                        const swiperYear = new Swiper(sliderYear, {
                            modules: [Pagination, EffectFade],
                            speed: 500,
                            effect: 'fade',
                            fadeEffect: {
                                crossFade: true,
                            },
                            slidesPerView: 1,
                            allowTouchMove: false,
                            spaceBetween: 0,
                            pagination: {
                                el: sliderYear.parentElement.querySelector(".swiper-pagination-custom"),
                                clickable: true,
                                renderBullet: (index, className) => {
                                    const getNameBullet = sliderYear.querySelectorAll('.swiper-slide-commitents-year')[index].dataset.tituloaba
                                    return '<button class="' + className + '">' + (getNameBullet) + "</button>";
                                },
                            },
                            lockClass: 'navigationLock'
                        });
                    }
    
                })
            })
            

            const btnOpenModals = section.querySelectorAll('.btnOpenModalCommitments')
            btnOpenModals.forEach(el => {
                el.addEventListener('click', () => {

                    const titulo = el.dataset.title
                    const image = el.dataset.image
                    const text = el.dataset.text
                    const percentage = el.dataset.percentage
                    const link = el.dataset.link

                    this.modalContent.innerHTML = ''
                    this.modalContent.innerHTML = this.templateModal(titulo, image, percentage, text, link);

                    this.modal.classList.add('open')

                    this.modal.querySelector('.closeModal').addEventListener('click', () => {
                        this.modal.classList.remove('open')
                    })
                })
            })

        })

    }
    
    templateThumbs(titulo) {
        const template = `
            <li class="swiper-slide">
                <button class="group text-">${titulo}</button>
            </li>
        `;
        return template
    }

    templateModal(titulo, imagem, porcentagem, texto, link) {
        let template = `
        <div class="relative bg-white dark:bg-black p-10 rounded-tl-full">
            <div class="flex lg:flex-row flex-col justify-between">
                <div class="lg:text-[2rem] text-lg text-unigreen700 dark:text-white font-semibold mb-3 w-full max-w-[36.875rem]">${titulo}</div>
                <div id="mcPicture">
                    <picture>
                        <img src="${imagem}" alt="${titulo}" class="asptec-ratio mb-4">
                    </picture>
                </div>
            </div>`;
            if(porcentagem) {
                template += `
                <div>Avanço atual do compromisso</div>
                <div>
                    <div class="bg-[#DDE7E4] flex items-start w-full rounded h-3 mt-7 mb-8">
                        <div class="bg-unigreen700 dark:bg-dark inline-flex rounded h-3 relative" style="width:${porcentagem}%"><div class="absolute text-black dark:text-white text-base right-0 -top-6">${porcentagem}%</div></div>
                    </div>
                </div>
                `;
            }
            template += `
                <div class="text-base text-black dark:text-white leading-normal mb-6">${texto}</div>
                <a href="${link}" class="btn-green-light mb-5"><span>Veja nosso relatório</span></a>
            </div>
            `;
        return template
    }

}

if (document.querySelector('.commitments')) {
    new Commitments();
}